export function canHandleColdLaunchRoute({
  handled,
  sourceReady,
  authHydrating,
  onboardingComplete,
}: {
  handled: boolean;
  sourceReady: boolean;
  authHydrating: boolean;
  onboardingComplete: boolean | null;
}) {
  return !handled && sourceReady && !authHydrating && onboardingComplete !== null;
}
